import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Card from '../../../../../1stlog-ui/src/components/Card'
import { useField } from '../../../../../1stlog-ui/src/components/Field'
import ListGroup, {
  ListGroupItem,
} from '../../../../../1stlog-ui/src/components/ListGroup'
import CustomerReferenceText from './CustomerReferenceText'
import EmailLabel from './EmailLabel'
import PrintLabel from './PrintLabel'

const Misc = (props) => {
  const {} = props

  const customerReferenceText = useField('customerReferenceText')

  const email = useField('pickup.address.mail')

  const requestLabelPrint = useField('requestLabelPrint')

  const isPrintRequested = useField('isPrintRequested')

  // Hide card completely
  if (!customerReferenceText && !requestLabelPrint && !isPrintRequested) {
    return null
  }

  return (
    <Card title={i18n.t('title_misc', 'Sonstiges')}>
      <ListGroup flush className="m-n2">
        {customerReferenceText && (
          <CustomerReferenceText value={customerReferenceText} />
        )}
        {isPrintRequested && <PrintLabel />}
        {requestLabelPrint && <EmailLabel email={email} />}
      </ListGroup>
    </Card>
  )
}

export default Misc
